import './App.css';
import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import LoginComponentPublic from './components/LoginComponentPublic';
import LoginComponentAdmin from './components/LoginComponentAdmin';
import LoginComponentClient from './components/LoginComponentClient';
import { AuthContextAdmin } from './context/AuthContextAdmin';
import { AuthContextPublic } from './context/AuthContextPublic';
import { AuthContextClient } from './context/AuthContextClient';
import Stream from './components/Stream';
import Settings from './components/Settings';
import Manage from './components/Manage';
import PageEdit from './components/PageEdit';
import LoginSessions from './components/LoginSessions';
import RegisteredUsers from './components/RegisteredUsers';
import QuestionBackEnd from './components/QuestionBackEnd';
import ClientVideoList from './components/ClientVideoList';
import ParticipantsBackEnd from './components/ParticipantsBackEnd';
import { firestore } from './Firebase';
import Lobby from './components/Lobby';
import Page from './components/Page';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Admin from './components/Admin';
import { TitleProvider } from './context/TitleContext';

function App() {
  return (
    <TitleProvider>
      <Routes>
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/questions/*" element={<ClientQuestionsRoutes />} />
        <Route path="/participants/*" element={<ClientParticipantsRoutes />} />
        <Route path="*" element={<PublicRoutes />} />
      </Routes>
    </TitleProvider>
  );
}

function PublicRoutes() {
  const { userPublic } = useContext(AuthContextPublic);
  const [features, setFeatures] = React.useState({});

  React.useEffect(() => {
    // We need to listen to features here to determine redirection
    const unsubscribe = firestore.collection('settings').doc('features').onSnapshot(doc => {
      if(doc.exists) {
        setFeatures(doc.data());
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <>
      {userPublic ? (
        <Routes>
          <Route path="/" element={features.hasConferenceModeOn ? <Lobby /> : <Stream />} />
          <Route path="/stream/:videoID" element={<Stream />} />
          <Route path="/page/:pageID" element={<Page />} />
        </Routes>
      ) : (
        <LoginComponentPublic />
      )}
    </>
  );
}

function AdminRoutes() {
  const { userAdmin } = useContext(AuthContextAdmin);

  return (
    <>
      {userAdmin ? (
        <Routes>
          <Route path="/" element={<Admin />}></Route>
          <Route path="/loginsessions" element={<LoginSessions />}></Route>
          <Route path="/registeredusers" element={<RegisteredUsers />}></Route>
          <Route path="/settings" element={<Settings />}></Route>
          <Route path="/manage/:videoID" element={<Manage />}></Route>
          <Route path="/page-edit/:pageID" element={<PageEdit />}></Route>
        </Routes>
      ) : (
        <LoginComponentAdmin />
      )}
    </>
  );
}

function ClientQuestionsRoutes() {
  const { userClient } = useContext(AuthContextClient);

  return (
    <>
      {userClient ? (
        <Routes>
          <Route path="/" element={<ClientVideoList />}></Route>
          <Route path="/:videoID" element={<QuestionBackEnd />}></Route>
        </Routes>
      ) : (
        <LoginComponentClient />
      )}
    </>
  );
}

function ClientParticipantsRoutes() {
  const { userClient } = useContext(AuthContextClient);

  return (
    <>
      {userClient ? (
        <Routes>
          <Route path="/" element={<ParticipantsBackEnd />}></Route>
        </Routes>
      ) : (
        <LoginComponentClient />
      )}
    </>
  );
}

export default App;
